import { useState } from 'react';
import { type GroupBase, type StylesConfig } from 'react-select';

import { useGetParentByStudio } from '~entities/parent/api/get-parent-by-studio';

import Select from '~shared/components/select/select';

interface ParentSelectorOption {
  label: string;
  value: string;
}

interface MultiParentSelectorProps {
  onChange: (value: Array<string>) => void;
  className?: string;
  styles?: StylesConfig<unknown, boolean, GroupBase<unknown>> | undefined;
  isOptionDisabled?: (
    option: ParentSelectorOption,
    selectValue: ReadonlyArray<ParentSelectorOption>,
  ) => boolean;
  filterOption?: (option: ParentSelectorOption, inputValue: string) => boolean;
  parentOptionsCount?: number;
}

export const MultiParentSelector = ({
  onChange,
  className,
  styles,
  isOptionDisabled,
  filterOption,
  parentOptionsCount = 10,
}: MultiParentSelectorProps) => {
  const [searchQuery, setSearchQuery] = useState<string>('');

  const [selectedParents, setSelectedParents] = useState<
    ReadonlyArray<ParentSelectorOption>
  >([]);

  const { data, isFetching } = useGetParentByStudio({
    search: searchQuery,
    limit: parentOptionsCount,
  });

  return (
    <Select
      isClearable
      isMulti
      value={selectedParents}
      onChange={(option) => {
        const opt = option as ReadonlyArray<ParentSelectorOption>;
        setSelectedParents(opt);
        onChange(opt.map((p) => p.value));
      }}
      placeholder='Select Parent'
      options={data?.data.map((p) => ({
        label: `${p.firstName} ${p.lastName}`,
        value: p._id,
      }))}
      isOptionDisabled={(option, selectValue) => {
        if (!isOptionDisabled) return false;

        return isOptionDisabled(
          option as ParentSelectorOption,
          selectValue as ReadonlyArray<ParentSelectorOption>,
        );
      }}
      filterOption={(option, inputValue) => {
        if (!filterOption) return true;

        return filterOption(option, inputValue);
      }}
      isLoading={isFetching}
      onInputChange={(inputValue) => {
        setSearchQuery(inputValue);
      }}
      className={className}
      styles={styles}
    />
  );
};
